import type { RouteLocation, Router } from 'vue-router';
import qs from 'qs';
import useMatestoreStore from '@/store/matestoreStore';
import Tracker from '@nio-fe/tracker-sdk';
/**
 * 埋点
 * page_source 必填，screen_name === page_source 是当前页面刷新
 */
const sensorsTrack = (to, from) => {
  try {
    const option = {
      $screen_name: to.name,
      page_source: from?.name || to.name,
      url: to.fullPath,
      requirement_id: 754,
      track_sign: 'aplatform.b2862.pageview.KeyPageEnter',
    };
    Tracker.track('KeyPageEnter', option);
  } catch (error) {
    console.error('埋点error', error);
  }
};
/**
 * 路由变换
 * @param router
 */
export default function createMicroGuard(router: Router) {
  const matestoreStore = useMatestoreStore();
  router.beforeEach((to, from, next) => {
    sensorsTrack(to, from);
    next();
  });
  const getPathWithQuery = (route: RouteLocation) => {
    return `${route.path}${
      Object.keys(route.query).length ? '?' : ''
    }${qs.stringify(route.query)}`;
  };
  router.beforeEach(async (to, from, next) => {
    console.log('route from', from?.fullPath, 'to', to?.fullPath);
    matestoreStore.closeImMicro();
    if (to.fullPath === from.fullPath) next();
    // if (to.path === '/message') {
    //   matestoreStore.openImMicro();
    //   return;
    // }

    matestoreStore.addMicroByRouter(to, from);
    if (to.name !== from.name) {
      matestoreStore.deactivateLatestOne();
    } else {
      // 兼容子应用path 默认的不同写法，重复页面不跳转

      const fromPath = getPathWithQuery(from);
      const toPath = getPathWithQuery(to);

      if (
        to.meta.isMicro &&
        fromPath == toPath &&
        ['', '#', '#/'].includes(to.hash) &&
        ['', '#', '#/'].includes(from.hash)
      ) {
        return;
      }
    }
    next();
  });
}
